export default __webpack_public_path__ + "static/10-challenges-4abfc7ec2e230e87380047325993d924.jpeg";